module.exports = __webpack_public_path__ + "img/logo-kapita-vins.025c3320.png";